// extracted by mini-css-extract-plugin
export default {"MonthsNavigation":"_4s-4w","activeMonthBox":"M9bGR","wrap":"uN5Cm","months":"Irk85","month":"uEPTN","year":"lCcD8","skeleton-progress":"_10D82"};